import api from "../../api/index";
import wx from "weixin-js-sdk";
import config from "../../../static/config.json";
import axios from "axios";
import vueThis from "../../main.js";
import { Toast } from "vant";

// 微信分享
const state = {
  baseApiList: {
    jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "hideMenuItems", "chooseImage", "uploadImage", "downloadImage"],
  }, // 基本 jssdk 配置
  url: "", // 首次进入的url
  isIos: window.__wxjs_is_wkwebview ? true : false, // 判断是否是ios 操作系统
  config: null, // jssdk 配置
  fromType: 0, // 0 专题页  , 1 店铺主页 , 2 热榜页
  fromData: null, // 分享的记录参数
};
const mutations = {
  setConfig(state, data) {
    state.config = data;
  },
  setUrl(state, data) {
    state.url = data;
  },
  setFromType(state, data) {
    state.fromType = data;
  },
  setFromData(state, data) {
    state.fromData = data;
  },
};
const getters = {
  getUrl: state => {
    return state.url;
  },
  getIsIos: state => {
    return state.isIos;
  },
  getConfig: state => {
    return state.config;
  },
  getFromType: state => {
    return state.fromType;
  },
  getFromData: state => {
    return state.fromData;
  },
};
const actions = {
  async getShareConfig({ rootState, dispatch }, id) {
    let query = `
      query($type: Int,$scope: String,$name:String){
        settingsQuery{
          by(type: $type,scope:$scope,name:$name){
            description
            displayName
            id
            isDeleted
            isEncrypted
            name
            scope
            scopeType
            value
          }
        }
      }
    `;
    let body = {
      queryName: "settingsQuery",
      query: query,
      variables: {
        type: 2,
        scope: id || rootState.exhibitionId,
        name: "share:en:config",
      },
    };
    let data = await dispatch("en/graphqlPostByZXS", body, {
      root: true,
    });
    return new Promise((resolve, reject) => {
      if (data.data.settingsQuery.by) {
        resolve(data.data.settingsQuery.by.value);
      } else {
        resolve(false);
      }
    });
  },
  async getSettingShare({ rootState, commit, dispatch }, opt) {
    let query = `
        query($type: Int,$scope: String,$name:String){
          settingsQuery{
            by(type: $type,scope:$scope,name:$name){
              description
              displayName
              id
              isDeleted
              isEncrypted
              name
              scope
              scopeType
              value
            }
          }
        }
      `;
    let body = {
      query: query,
      variables: {
        type: 2,
        scope: opt.id,
        name: opt.name,
      },
    };
    let data = await dispatch("en/graphqlPostByZXS", body, {
      root: true,
    });
    return new Promise((resolve, reject) => {
      if (data.data.settingsQuery.by) {
        resolve(data.data.settingsQuery.by.value);
      } else {
        resolve(false);
      }
    });
  },
  /**
   * 自定义占位符字段替换设置分享模板
   * @param {temp, objTemp}
   * temp = '【公司】邀请你来参观'
   * objTemp = {CompanyName: '上海联展软件技术有限公司'}
   */
  generateShareTemplate({}, { temp, objTemp }) {
    console.log(temp, objTemp);
    let shareTemp = temp.replace(/(【[\u4e00-\u9fa5]+】)/g, w => {
      const word = w.replace(/(【|】)/g, "");
      let str = "";
      switch (word) {
        case "公司":
          str = objTemp.CompanyName;
          break;
        case "展位号":
          str = objTemp.booth;
          break;
        case "展品":
          str = objTemp.pro;
          break;
        case "卖点":
          str = objTemp.selling;
          break;
        case "活动":
          str = objTemp.act;
          break;
        case "话题":
          str = objTemp.talk;
          break;
        case "导语":
          str = objTemp.remarks;
          break;
      }
      return str;
    });
    return Promise.resolve(shareTemp);
  },
  /**
   * 根据移动操作系统不同 根据分享内容来分享
   * @param {*} opt = {message: {}, timeline: {}}
   */
  async wxSharePage({ dispatch, commit, rootGetters }, opt = null) {
    const itemId = rootGetters.getEntranceId;
    const config = opt;
    await dispatch("getConfig"); // 获取并设置微信jssdk
    await dispatch("shareToWechat", config); // 分享成功
  },
  /**
   * 获取配置 判断是什么操作系统 如果是ios 则使用第一次进入页面存的地址， 反之安卓使用当前的url
   */
  getConfigByOnce({ state, commit, getters, rootState }) {
    const url = state.isIos ? window.url.split("#")[0] : window.location.href.split("#")[0];
    if (state.isIos) {
      console.log("是ios系统");
      console.log("当前网址是: " + url);
    }
    return new Promise((resolve, reject) => {
      api
        .post(`${config.https.api}/api/v1/wechat/jsapi-config`, {
          url: url,
        })
        .then(({ data }) => {
          commit("setConfig", data);
          if (!window.config) {
            window.config = data;
            console.log("第一次  window.config： ", data);
          }
          resolve(data);
        })
        .catch(err => console.log(err));
    });
  },
  /**
   * 设置wx jsskd配置
   */
  async getConfig({ dispatch, getters, state }) {
    let config = {};
    if (state.isIos && window.config) {
      // ios下且有配置时使用以前的配置 反之都请求配置
      config = window.config;
    } else {
      config = await dispatch("getConfigByOnce");
    }
    wx.config({
      ...config,
      ...state.baseApiList,
      // debug: true,
    });
    return Promise.resolve(true);
  },
  /**
   * 分享到朋友圈 和 消息
   * @param {*} opt = {message 分享消息的内容, timeline 分享朋友圈的内容}
   */
  shareToWechat({ getters, dispatch }, opt) {
    console.log(opt, "分享的配置");
    return new Promise((resolve, reject) => {
      wx.ready(function() {
        dispatch("wxHide");
        wx.onMenuShareAppMessage({
          title: opt.title,
          desc: opt.desc,
          link: opt.link ? opt.link : window.location.href,
          imgUrl: opt.imgUrl,
          success: res => {
            console.log("onMenuShareTimeline: 分享成功！", 111);
            // Toast.success({
            //   message:'分享成功',
            //   closeOnClick :true
            // });
            dispatch("addshare");
            vueThis.$Bus.$emit("shareOk");
            resolve("ok");
          },
          cancel: res => {
            Toast.fail({
              message: "Sharing canceled",
              closeOnClick: true,
            });
            resolve("cancel");
          },
          fail: res => {
            console.log(res, "失败");
            Toast.fail({
              message: "Failed to share",
              closeOnClick: true,
            });
            vueThis.$Bus.$emit("shareFail");
            resolve("fail");
          },
        });
        wx.onMenuShareTimeline({
          title: opt.isNeed ? opt.desc : opt.title,
          desc: opt.desc,
          link: opt.link ? opt.link : window.location.href,
          imgUrl: opt.imgUrl,
          success: res => {
            console.log("onMenuShareTimeline: 分享成功！");
            // Toast.success({
            //   message:'分享成功',
            //   closeOnClick :true
            // });
            dispatch("addshare");
            vueThis.$Bus.$emit("shareOk");
            resolve("ok");
          },
          cancel: res => {
            Toast.fail({
              message: "Sharing canceled",
              closeOnClick: true,
            });
            console.log("取消了");
            resolve("cancel");
          },
          fail: res => {
            Toast.fail({
              message: "Failed to share",
              closeOnClick: true,
            });
            vueThis.$Bus.$emit("shareFail");
            resolve("fail");
          },
        });
      });
    });
  },
  /**
   * 微信隐藏工具栏菜单  抽象方法
   */
  wxHide({}) {
    //
    wx.hideMenuItems({
      menuList: ["menuItem:copyUrl", "menuItem:originPage", "menuItem:openWithQQBrowser", "menuItem:openWithSafari", "menuItem:share:email", "menuItem:share:brand", "menuItem:share:weiboApp", "menuItem:share:facebook", "menuItem:share:QZone"],
      success: function(res) {},
      fail: function(res) {},
    });
  },
  wxHideAllMenu() {
    // 隐藏所有微信分享的菜单
    wx.ready(function() {
      wx.hideMenuItems({
        menuList: [
          "menuItem:share:appMessage",
          "menuItem:share:timeline",
          // "menuItem:share:qq",
          "menuItem:share:weiboApp",
          "menuItem:favorite",
          "menuItem:share:facebook",
          "menuItem:share:QZone",
          "menuItem:editTag",
          "menuItem:delete",
          "menuItem:copyUrl",
          "menuItem:originPage",
          "menuItem:openWithQQBrowser",
          "menuItem:openWithSafari",
          "menuItem:share:email",
          "menuItem:share:brand",
        ],
        success: function(res) {
          console.log("隐藏所有微信分享的菜单success");
        },
        fail: function(res) {
          console.log("隐藏所有微信分享的菜单fail");
        },
      });
    });
  },
  addshare({ getters, dispatch }, opt) {
    if (getters.getFromData) {
      // 有分享记录的参数
      switch (getters.getFromType) {
        case 0: // 添加展会分享
          dispatch("addExhibintonShare");
          break;
        case 1: // 添加参展的分享记录(专题页,店铺主页)
          dispatch("addExhibitorShare");
          break;
        case 2: // 添加热榜的分享记录
          dispatch("addhotShare");
          break;
        case 3: // 添加产品的分享记录
          dispatch("addProductShare");
          break;
        case 4: // 添加活动的分享记录
          dispatch("addActShare");
          break;
      }
    }
  },
  addExhibintonShare({ getters, rootState }, body) {
    // 添加展会分享
    axios
      .post(`${config.https.api}/api/v1/exhibition/share`, getters.getFromData, rootState.header)
      .then(res => {
        if (res.status === 200 && res.data) {
          // resolve(res.data);
        }
      })
      .catch(err => console.log(err));
  },
  addhotShare({ getters, rootState }, body) {
    // 添加热榜的分享记录
    axios
      .post(`${config.https.api}/api/v1/livepopularize/share`, getters.getFromData, rootState.header)
      .then(res => {
        console.log(res, "热榜的分享");
        if (res.status === 200 && res.data) {
          // resolve(res.data);
        }
      })
      .catch(err => console.log(err));
  },
  addExhibitorShare({ getters, rootState }, body) {
    // 添加参展的分享记录(专题页,店铺主页)
    axios
      .post(`${config.https.api}/api/v1/exhibitor/share`, getters.getFromData, rootState.header)
      .then(res => {
        console.log(res, "参展的分享记录(专题页,店铺主页)");
        if (res.status === 200 && res.data) {
          // resolve(res.data);
        }
      })
      .catch(err => console.log(err));
  },
  addProductShare({ getters, rootState }, body) {
    // 添加产品的分享记录
    axios
      .post(`${config.https.api}/api/v1/productshare`, getters.getFromData, rootState.header)
      .then(res => {
        console.log(res, "产品的分享记录");
        if (res.status === 200 && res.data) {
          // resolve(res.data);
        }
      })
      .catch(err => console.log(err));
  },
  addActShare({ getters, rootState }, body) {
    // 添加活动的分享记录
    axios
      .post(`${config.https.api}/api/v3/activity/share`, getters.getFromData, rootState.header)
      .then(res => {
        console.log(res, "活动的分享记录");
        if (res.status === 200 && res.data) {
          // resolve(res.data);
        }
      })
      .catch(err => console.log(err));
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
